import { FlagsProvider } from 'flagged';
import { isLoggedIn } from '@nordvpn/teams.core/lib/auth/utils/localStorage';
import { useFeatureFlags } from 'api/FeatureFlags/queries';
import { jsx as _jsx } from "react/jsx-runtime";
export var FeatureFlagsProvider = function FeatureFlagsProvider(_ref) {
    var children = _ref.children;
    var _useFeatureFlags = useFeatureFlags({
        enabled: isLoggedIn()
    }), data = _useFeatureFlags.data;
    return /*#__PURE__*/ _jsx(FlagsProvider, {
        features: data !== null && data !== void 0 ? data : {},
        children: children
    });
};
